import React from 'react';
import { Leaf } from 'lucide-react';
export function SectionDivider() {
  return <div className="w-full bg-white py-2 md:py-4 flex items-center justify-center overflow-hidden relative" data-id="element-480">
      <style data-id="element-481">
        {`
          @keyframes float-leaf {
            0%, 100% { transform: translateY(0) rotate(-5deg); }
            50% { transform: translateY(-10px) rotate(5deg); }
          }
          @keyframes pulse-dot {
            0%, 100% { opacity: 0.3; transform: scale(0.8); }
            50% { opacity: 1; transform: scale(1.2); }
          }
          .animate-float-leaf {
            animation: float-leaf 4s ease-in-out infinite;
          }
          .animate-pulse-dot-1 {
            animation: pulse-dot 3s ease-in-out infinite;
          }
          .animate-pulse-dot-2 {
            animation: pulse-dot 3s ease-in-out infinite 1.5s;
          }
        `}
      </style>

      <div className="max-w-3xl w-full flex items-center justify-center px-8" data-id="element-482">
        {/* Left Line */}
        <div className="h-px flex-1 bg-gradient-to-r from-transparent via-forest/10 to-forest/30" data-id="element-483"></div>

        {/* Center Ornament */}
        <div className="px-6 flex items-center gap-5 relative" data-id="element-484">
          <div className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse-dot-1" data-id="element-485"></div>

          <div className="text-forest animate-float-leaf drop-shadow-sm" data-id="element-486">
            <Leaf size={32} strokeWidth={1.5} className="fill-forest/5" data-id="element-487" />
          </div>

          <div className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse-dot-2" data-id="element-488"></div>
        </div>

        {/* Right Line */}
        <div className="h-px flex-1 bg-gradient-to-l from-transparent via-forest/10 to-forest/30" data-id="element-489"></div>
      </div>
    </div>;
}